export const teammateConstants = {
    TEAMMATE_LOADING: 'TEAMMATE_LOADING',
    GETTEAMMATE_SUCCESS: 'GET_TEAMMATE_SUCCESS',
    GETTEAMMATE_FAILURE: 'GET_TEAMMATE_FAILURE',
    PUTTEAMMATE_SUCCESS: 'PUT_TEAMMATE_SUCCESS',
    PUTTEAMMATE_FAILURE: 'PUT_TEAMMATE_FAILURE',
    POSTTEAMMATE_SUCCESS: 'POST_TEAMMATE_SUCCESS',
    POSTTEAMMATE_FAILURE: 'POST_TEAMMATE_FAILURE',
}
